export default "__VITE_ASSET__BLOdnJGP__"